"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _airbnbPropTypes = require("airbnb-prop-types");

var _styler = _interopRequireDefault(require("../Styler/styler"));

var _unique = _interopRequireDefault(require("../helpers/unique.id"));

var _getNativeProps = _interopRequireDefault(require("../helpers/get-native-props"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Toggle = function Toggle(_ref) {
  var children = _ref.children,
      checked = _ref.checked,
      id = _ref.id,
      name = _ref.name,
      value = _ref.value,
      onChange = _ref.onChange,
      tabIndex = _ref.tabIndex,
      props = _objectWithoutProperties(_ref, ["children", "checked", "id", "name", "value", "onChange", "tabIndex"]);

  var uid = id || (0, _unique.default)();
  return _react.default.createElement(_styler.default, {
    modifiers: props,
    className: "co-toggle"
  }, function (styles) {
    return _react.default.createElement("div", _extends({
      className: styles
    }, (0, _getNativeProps.default)(props)), _react.default.createElement("div", {
      className: "co-toggle__switch"
    }, _react.default.createElement("input", {
      id: uid,
      name: name,
      type: "checkbox",
      checked: checked,
      disabled: props.disabled,
      onChange: onChange,
      value: value,
      tabIndex: tabIndex
    })), children ? _react.default.createElement("label", {
      htmlFor: uid
    }, children) : null);
  });
};

var exclusiveSizes = (0, _airbnbPropTypes.mutuallyExclusiveTrueProps)('small', 'large');
Toggle.propTypes = {
  children: _propTypes.node,
  onChange: _propTypes.func.isRequired,
  alignRight: _propTypes.bool,
  checked: _propTypes.bool,
  disabled: _propTypes.bool,
  id: _propTypes.string,
  name: _propTypes.string,
  large: exclusiveSizes,
  small: exclusiveSizes,
  value: _propTypes.string.isRequired,
  tabIndex: _propTypes.string
};
Toggle.defaultProps = {
  checked: false
};
var _default = Toggle;
exports.default = _default;
Toggle.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Toggle",
  "props": {
    "checked": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "children": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": ""
    },
    "onChange": {
      "type": {
        "name": "func"
      },
      "required": true,
      "description": ""
    },
    "alignRight": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "disabled": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "id": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "name": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "large": {
      "type": {
        "name": "custom",
        "raw": "exclusiveSizes"
      },
      "required": false,
      "description": ""
    },
    "small": {
      "type": {
        "name": "custom",
        "raw": "exclusiveSizes"
      },
      "required": false,
      "description": ""
    },
    "value": {
      "type": {
        "name": "string"
      },
      "required": true,
      "description": ""
    },
    "tabIndex": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    }
  }
};